import { render } from "./FAQFormModal.vue?vue&type=template&id=fdc6c576"
import script from "./FAQFormModal.vue?vue&type=script&lang=js"
export * from "./FAQFormModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/phi-indonesia/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__